import { render, staticRenderFns } from "./FundNavInvestments.vue?vue&type=template&id=087730a0&scoped=true"
import script from "./FundNavInvestments.vue?vue&type=script&lang=js"
export * from "./FundNavInvestments.vue?vue&type=script&lang=js"
import style0 from "./FundNavInvestments.vue?vue&type=style&index=0&id=087730a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087730a0",
  null
  
)

export default component.exports